export default {
  RiskServiceInterface: Symbol('RiskServiceInterface'),
};
